const ROOT = 'dashboard/settings/location/cities';

export default {
	arrayList: `${ROOT}/list`,
	arrayListToDropdown: `${ROOT}/by-state/`,
	store: `${ROOT}`,
	show: `${ROOT}/`,
	status: `${ROOT}/status/`,
	update: `${ROOT}/`,
	destroy: `${ROOT}/`,
};
